import moment from "moment";
import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import { twMerge } from "tailwind-merge";
import { useMask } from "@react-input/mask";
import Input from "components/input";

type InputProps = {
  placeholder?: string;
  id?: string;
  label?: string;
  error?: any;
  type?: string;
  [x: string]: any;
};

const CustomInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const inputRef = useMask({
    mask: "__/__/____",
    replacement: { _: /\d/ },
  });
  return <Input type="text" ref={inputRef} {...props} />
})

const DatePicker = React.forwardRef((props: InputProps, ref: any) => {
  const selectedDateString = moment.utc(props.value).format("YYYY-MM-DD");

  return (
    <ReactDatePicker 
      selected={props.value ? moment(selectedDateString).toDate() : null}
      onChange={props.onChange}
      wrapperClassName="w-full"
      placeholderText={props.placeholder ? `${props.placeholder} (dd/mm/yyyy)` : "DD/MM/YYYY"}
      dateFormat="dd/MM/yyyy"
      className={twMerge(
        `input ${
          props.error
            ? "border-red-600 focus:border-red-600"
            : "border-gray-300 focus:border-brand-500"
        }`,
        props.className
      )}
      ref={ref}
      customInput={(<CustomInput onChange={props.onChange} />)}
      maxDate={props.maxDate ?? null}
    />
  )
});

DatePicker.displayName = "DatePicker";

export default DatePicker;
